function useInput({ hasHint = false, id, isInvalid = false, isRequired = false }) {
    return {
        labelProps: {
            htmlFor: id
        },
        inputProps: {
            id,
            name: id
        },
        inputA11yProps: {
            'aria-invalid': isInvalid,
            'aria-required': isRequired,
            'aria-describedby': [isInvalid && `${id}-error`, hasHint && `${id}-description`]
                .filter(Boolean)
                .join(' ')
        }
    };
}
export { useInput };
//# sourceMappingURL=useInput.js.map